import { render, staticRenderFns } from "./force_alert.vue?vue&type=template&id=0f26a02d&"
import script from "./force_alert.vue?vue&type=script&lang=js&"
export * from "./force_alert.vue?vue&type=script&lang=js&"
import style0 from "./force_alert.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports